import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import HomeIcon from "./../../assets/images/icons/leftbar/home.png";
import InplayIcon from "./../../assets/images/icons/leftbar/inplay.png";
import CricketIcon from "./../../assets/images/icons/leftbar/cricket.png";
import SoccerIcon from "./../../assets/images/icons/leftbar/soccer.png";
import TennisIcon from "./../../assets/images/icons/leftbar/tennis.png";
import horseracingIcon from "./../../assets/images/games-icon/horseracing-icon.png";
import SnookerIcon from "./../../assets/images/games-icon/snooker-icon.png";
import GreyhoundIcon from "./../../assets/images/games-icon/greyhoundracing-icon.png";
import PoliticsIcon from "./../../assets/images/games-icon/politics-icon.png";
import EzugiIcon from "./../../assets/images/icons/leftbar/ezugi.png";
import EvolutionIcon from "./../../assets/images/icons/leftbar/evolution.png";
import VivoIcon from "./../../assets/images/icons/leftbar/vivo.png";
import SupernowaIcon from "./../../assets/images/icons/leftbar/supernowa.png";
import xpgIcon from "./../../assets/images/icons/leftbar/xpg.png";
import WorldcasinoIcon from "./../../assets/images/icons/leftbar/worldcasino.png";
import SlotsIcon from "./../../assets/images/icons/leftbar/slots.png";
import Whatsapp from "./../../assets/images/Whatsapp.svg";
import Telegram from "./../../assets/images/telegram.svg";
import Instagram from "./../../assets/images/Instagram.svg";
import Facebook from "./../../assets/images/facebook-512.svg";
import { Accordion } from "react-bootstrap";

const LeftBarSports = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  const tabs = [
    {
      id: 1,
      eventKey: "1",
      name: "In play",
    },
    {
      id: 2,
      eventKey: "2",
      name: "Cricket",
    },
    {
      id: 3,
      eventKey: "3",
      name: "Soccer",
    },
    {
      id: 4,
      eventKey: "4",
      name: "Tennis",
    },
  ];

  return (
    <>
      <div className="leftbarSec d-none d-md-block">
        <Accordion defaultActiveKey="0" className="LeftbarSection">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Racing Sports</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <div
                    onClick={() => {
                      navigate("/sportsbook/Horse Racing", {});
                    }}
                  >
                    <span>Horse Racing</span>
                  </div>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="1" className="LeftbarSection">
          <Accordion.Item eventKey="1">
            <Accordion.Header>Others</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <div
                    onClick={() => {
                      navigate("/Casino", {});
                    }}
                  >
                    <span>Our Casino</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/ezugi", {});
                    }}
                  >
                    <span>Ezugi</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/evolution");
                    }}
                  >
                    <span>Evolution</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/vivo");
                    }}
                  >
                    <span>Vivo</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/supernowa");
                    }}
                  >
                    <span>Supernowa</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/xpg");
                    }}
                  >
                    <span>XPG</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/worldcasino");
                    }}
                  >
                    <span>Worldcasino</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/slots");
                    }}
                  >
                    <span>Slots</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/Spribe");
                    }}
                  >
                    <span>Spribe</span>
                  </div>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="2" className="LeftbarSection">
          <Accordion.Item eventKey="2">
            <Accordion.Header>All Sports</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <div
                    onClick={() => {
                      navigate("/sportsbook/Cricket", {});
                    }}
                  >
                    <span>In-play</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/sportsbook/Cricket", {});
                    }}
                  >
                    <span>Cricket</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/sportsbook/Soccer", {});
                    }}
                  >
                    <span>Soccer</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/sportsbook/Tennis", {});
                    }}
                  >
                    <span>Tennis</span>
                  </div>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default LeftBarSports;
